import { getBulkInput } from './factories';

export const getBulkCurrencyPair = getBulkInput('currencyPair');
export const getBulkAmountCurrency = getBulkInput('amountCurrency');
